import resourceListSelectorFactory from '../utility/resourceListSelectorFactory';
import byIdSelectorFactory from '../utility/byIdSelectorFactory';
import { getAllRanges } from './all';
import presentation2Range from './2.x/range';

var range = presentation2Range;

export default range;

export var ranges = resourceListSelectorFactory(getAllRanges, range);

export var rangeByIdSelector = byIdSelectorFactory(range, 'ranges');